
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { chunk } from 'lodash';

import md5 from 'md5';

@Component
export default class ActivitiesFilterCard extends Vue {
   @Prop({ type: [String] }) title!: string;
   @Prop({ type: [Boolean], default: false }) search!: any[];
   @Prop({ type: [Array], default: () => [] }) items!: string[];
   @Prop({ type: [Array, String], default: () => [] }) value!: string[] | string;

   card_id: string = '';

   item_search: string = '';

   checked: string[] = [];

   filtered_items: any[] = [];

   mounted(): void {
      this.card_id = md5(JSON.stringify(this.items) + this.title);
      this.checked = Array.isArray(this.value) ? this.value : [];
      this.onChangeSearch();
   }

   getChunk(items: any, l: number) {
      return chunk(items, l);
   }

   elId(el: any) {
      return el.id ?? el.o_id ?? el.d_id;
   }

   elName(el: any) {
      return el.name ?? el.o_name ?? el.d_name;
   }

   @Watch('checked', { deep: true })
   onChangeValue(n: any[]) {
      this.$emit('input', n);
   }

   @Watch('item_search')
   onChangeSearch(item_search: string = '') {
      this.filtered_items = this.items.filter(item => {
         return (
            item_search === '' ||
            this.elName(item)
               .toLowerCase()
               .indexOf(item_search.toLowerCase()) >= 0
         );
      });
   }
}
